import script from "./Customs.vue?vue&type=script&setup=true&lang=js"
export * from "./Customs.vue?vue&type=script&setup=true&lang=js"

import "./Customs.vue?vue&type=style&index=0&id=629ffbd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-629ffbd6"]])

export default __exports__